<div class="page tracking history">
  <app-left-data></app-left-data>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="bottomright" id="bottomright">
      <div class="btns">
        <div class="btn_tabs">
          <button class="active" (click)="this.openTabTrackingRight('rawdata_info', 1)">{{'Raw data'|translate }}</button>
          <button id="showdriversessionsbtn" (click)="this.openTabTrackingRight('driversessions_info', 2)">{{'Driver sessions'|translate }}</button>
          <button id="showdailystatbtn" (click)="this.openTabTrackingRight('dailystat_info', 3)">{{'Daily statistics'|translate }}</button>
        </div>
        <div>
          <input type="text" class="dtpickerupleft" value="" />
        </div>
        <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
      </div>
      <div class="rightreport">
        <app-raw-data></app-raw-data>
        <app-driver-sessions></app-driver-sessions>
        <app-daily-stat></app-daily-stat>
      </div>
    </div>
  </div>
</div>
